// /src/pages/Billing.js
import React from "react";
import BillingComponent from "../components/BillingComponent";

const Billing = () => {
  return (
    <>
      <BillingComponent />
    </>
  );
};

export default Billing;
